import VuexPersistence from "vuex-persist";

const localStoragePlugin = new VuexPersistence({
  strictMode: process.env.NODE_ENV !== "production",
  storage: window.localStorage,
  modules: ["login"]
});

export { localStoragePlugin };
